export enum CrmLeadInfoDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  FromEHR = 'From EHR'
}

export enum CrmLeadInfoOriginInboundType {
  PROSPECTIVE_RESIDENT = 'PROSPECTIVE_RESIDENT',
  RESIDENT_CLOSE_CONNECTION = 'RESIDENT_CLOSE_CONNECTION',
  REFERRAL_SOURCE = 'REFERRAL_SOURCE',
  REFERRAL_SOURCE_COMPANY = 'REFERRAL_SOURCE_COMPANY'
}

export enum CrmLeadInfoOriginOutboundType {
  PROSPECTIVE_RESIDENT = 'PROSPECTIVE_RESIDENT',
  RESIDENT_CLOSE_CONNECTION = 'RESIDENT_CLOSE_CONNECTION',
  REFERRAL_SOURCE = 'REFERRAL_SOURCE',
  REFERRAL_SOURCE_COMPANY = 'REFERRAL_SOURCE_COMPANY'
}

export enum CrmLeadInfoHeardType {
  REFERRAL_SOURCE = 'REFERRAL_SOURCE',
  REFERRAL_SOURCE_COMPANY = 'REFERRAL_SOURCE_COMPANY',
  VIA_OUTBOUND = 'VIA_OUTBOUND',
  SURVEY = 'SURVEY'
}

export const originInboundToDisplayMapping: Record<
  CrmLeadInfoOriginInboundType,
  string
> = {
  PROSPECTIVE_RESIDENT: 'Prospective Resident',
  RESIDENT_CLOSE_CONNECTION: 'Resident Family Or Friend',
  REFERRAL_SOURCE: 'Referral Source',
  REFERRAL_SOURCE_COMPANY: 'Referral Source Company'
};

export const originOutboundToDisplayMapping: Record<
  CrmLeadInfoOriginOutboundType,
  string
> = {
  PROSPECTIVE_RESIDENT: 'Prospective Resident',
  RESIDENT_CLOSE_CONNECTION: 'Resident Family Or Friend',
  REFERRAL_SOURCE: 'Referral Source',
  REFERRAL_SOURCE_COMPANY: 'Referral Source Company'
};

